import React from 'react';
import InstanceControlPanel from './instanceControlPanel/instanceControlPanel.js';
import './instances.css';

const Instances = (props) => {

  const {
    monitoring,
    preferences,
    removeFromMonitoring,
    reorderMonitoring
  } = props;

  // This is the main area where the instance screenshots are displayed.
  return (
    <div className="Instances">
      {monitoring.map(instance => {
        return <InstanceControlPanel
          instance={instance}
          key={`${instance.InstanceId}`}
          preferences={preferences}
          removeFromMonitoring={removeFromMonitoring}
          reorderMonitoring={reorderMonitoring}
        />;
      })}
    </div>
  );

};

export default Instances;


// WEBPACK FOOTER //
// ./src/components/content/instanceScreenshotViewer/instances/instances.js